import { render, staticRenderFns } from "./MDM.vue?vue&type=template&id=05eefc23&scoped=true&"
import script from "./MDM.vue?vue&type=script&lang=js&"
export * from "./MDM.vue?vue&type=script&lang=js&"
import style0 from "./MDM.vue?vue&type=style&index=0&id=05eefc23&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05eefc23",
  null
  
)

export default component.exports